<template>
  <v-combobox
    ref="select"
    :label="label"
    v-model="select"
    :items="items"
    clearable
    @click:clear="clear()"
  />
</template>

<script>
export default {
  name: "SearcherSelect",

  props: { value: String, label: String, items: Array },

  components: {},

  data: () => ({
    select: null,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.select = this.value;
      },
    },
    select: {
      handler() {
        this.$emit("input", this.select);
      },
    },
  },

  methods: {
    clear() {
      this.$refs.select.lazySearch = null;
      this.$emit("input", null);
    },
  },
};
</script>
